import { render, staticRenderFns } from "./ImportDataUpload.vue?vue&type=template&id=0166ba78&scoped=true"
import script from "./ImportDataUpload.vue?vue&type=script&lang=js"
export * from "./ImportDataUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0166ba78",
  null
  
)

export default component.exports